module.exports = __webpack_public_path__ + "static/img/logo.e0675998.png";